import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {getAllRecordings, updateRecording, bulkUpdateRecordings} from "./API";

export const getRecordingsThunk = createAsyncThunk(
    'recordings/getRecordings',
    async (spaceId) => {
        return getAllRecordings(spaceId)
    }
)

export const updateRecordingThunk = createAsyncThunk(
    'recordings/updateRecording',
    (data) => {
        return updateRecording(data.spaceId, data.data)
    }
)

export const bulkUpdateRecordingsThunk = createAsyncThunk(
    'recordings/bulkUpdateRecordings',
    (data) => {
        return bulkUpdateRecordings(data.spaceId, data.recordingIds, data.songId)
    }
)


const RecordingsSlice = createSlice({
    name: 'recordings',
    initialState: {recordings: [], currentRecording: null, currentRecordingUpdatedAt: 0, loading: 'idle'},
    reducers: {
        updateCurrentRecording(state, action) {
            state.currentRecording = action.payload;
            state.currentRecordingUpdatedAt = Date.now();
        }
    },
    extraReducers: {
        [getRecordingsThunk.pending]: (state, action) => {
            state.status = 'loading'
        },
        [getRecordingsThunk.rejected]: (state, action) => {
            state.status = 'failed'
            state.error = action.error.message
        },
        // Add reducers for additional action types here, and handle loading state as needed
        [getRecordingsThunk.fulfilled]: (state, action) => {
            state.recordings = Array.isArray(action.payload) ? action.payload : []
        }
    }
})

export default RecordingsSlice.reducer
export const {updateCurrentRecording} = RecordingsSlice.actions
